import './styles.css';

export type LayoutProps = {
	delete: JSX.Element;
	duplicate: JSX.Element;
	edit: JSX.Element;
	divProps?: React.HTMLAttributes<HTMLDivElement>;
};

export const Layout: React.FC<LayoutProps> = ({
	edit,
	duplicate,
	divProps,
	...props
}) => (
	<div
		{...divProps}
		className={`cart-buttons-layout d-flex${
			divProps?.className ? ` ${divProps?.className}` : ''
		}`}
	>
		{props.delete}

		{duplicate}

		{edit}
	</div>
);
